<!-- ----------------------------------------------- -->
<template>
  <v-sheet
    v-if="this.valuesList.length != 0"
    class="container-column"
    style="height: 100%;"
  >
    <v-data-table
      :headers="headersList"
      :items="valuesList"
      :items-per-page="this.valuesList.length"
      item-key="cd"
      hide-default-footer
      disable-sort
      fixed-header
      height="100%"
      class="container-column"
    >
      <template v-slot:[`item.tidlvl`]="{ item }">
        <span
          v-if="showCoastHighlight(item.tidlvlovcutwrn)"
          class="tm-pc-detail-coast-ovlvl-color-highlight"
          :rw-info-color="setCoastInfoColor(item.tidlvlovcutwrn)"
        >
          {{ item.tidlvl }}
        </span>
        <span v-else> {{ item.tidlvl }} </span>
      </template>
      <template v-slot:[`item.onthwvhght`]="{ item }">
        <span
          v-if="showCoastHighlight(item.onthwvhghtcutwrn)"
          class="tm-pc-detail-coast-ovlvl-color-highlight"
          :rw-info-color="setCoastInfoColor(item.onthwvhghtcutwrn)"
        >
          {{ item.onthwvhght }}
        </span>
        <span v-else> {{ item.onthwvhght }} </span>
      </template>
      <template v-slot:[`item.wndspd`]="{ item }">
        <span
          v-if="showCoastHighlight(item.wndspdovfcutwrn)"
          class="tm-pc-detail-coast-ovlvl-color-highlight"
          :rw-info-color="setCoastInfoColor(item.wndspdovfcutwrn)"
        >
          {{ item.wndspd }}
        </span>
        <span v-else> {{ item.wndspd }} </span>
      </template>
    </v-data-table>
  </v-sheet>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]海岸 (詳細)観測値一覧カード
 * TmCoastDetailValues.vue
 * @author LIS
 */

export default {
  name: "tm-coast-values",
  computed: {
    /**
     * 表示時刻設定(0:時間単位、1:10分単位) 取得
     */
    timeMode: {
      get() {
        return this.$store.state.Telemeter.timeMode;
      },
    },
    /**
     * ヘッダ情報 取得
     */
    headersList: {
      get() {
        if (!this.timeMode) {
          // 10分単位
          return this.min10List.headers;
        }
        // 時間単位
        return this.hourList.headers;
      },
    },
    /**
     * 観測値一覧 取得
     */
    valuesList: {
      get() {
        if (!this.timeMode) {
          // 10分単位
          return this.min10List.values;
        }
        // 時間単位
        return this.hourList.values;
      },
    },
    /**
     * 海岸情報(時間) 取得
     */
    hourList: {
      get() {
        return this.$store.state.Telemeter.selectedTm.obsValues.hour;
      },
    },
    /**
     * 海岸情報(10分) 取得
     */
    min10List: {
      get() {
        return this.$store.state.Telemeter.selectedTm.obsValues.min10;
      },
    },
  },
  methods: {
    /**
     * 超過観測所 着色
     */
    setCoastInfoColor(lvlovcutwrn) {
      if (lvlovcutwrn === 2) {
        return "danger";
      } else if (lvlovcutwrn === 1) {
        return "refuge";
      }
    },
    /** 超過の強調表示をするか */
    showCoastHighlight(lvlovcutwrn) {
      if (lvlovcutwrn === 1 || lvlovcutwrn === 2) {
        return true;
      }
      return false;
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
